import React from 'react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import LoginComponent from './LoginComponent';
import ResendEmailComponent from './ResendEmailComponent';
import RegistrationConfirmation from "./RegistrationConfirmation";

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleGoogleSuccess = this.handleGoogleSuccess.bind(this);
        this.handleGoogleFailure = this.handleGoogleFailure.bind(this);
        this.gotToRegister = this.gotToRegister.bind(this);
        this.gotToForgotPassword = this.gotToForgotPassword.bind(this);
        this.goToLogin = this.goToLogin.bind(this);
        this.goToSubscription = this.goToSubscription.bind(this);
        this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
        this.handleMicrosoftLogin = this.handleMicrosoftLogin.bind(this);
        this.goToNewAccount = this.goToNewAccount.bind(this);
        this.goToSetupCredentials = this.goToSetupCredentials.bind(this);
        this.onToggleOtpMode = this.onToggleOtpMode.bind(this);
        this.onResendOtp = this.onResendOtp.bind(this);
    }

    componentDidMount() {
        const script = document.createElement('script');
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.onload = () => {
            this.googleAuthClient = window.google.accounts.oauth2.initCodeClient({
                client_id: "964252966658-8c590709chc294dsmm5hrc9qg7kvsoab.apps.googleusercontent.com",
                scope: "openid email profile",
                callback: this.handleGoogleSuccess,
                redirect_uri: "http://localhost:3000",
            });
        };
        document.body.appendChild(script);
    }

    handleGoogleSuccess(response) {

        if (response.code) {
            const idToken = response.code;
            let fromUrl = null;
        if (this.props.location.state && this.props.location.state.from) {
            fromUrl = this.props.location.state.from.pathname;
        }
            dispatch.login.googleLoginAsync({ idToken,fromUrl });
        } else {
            console.error('Google login failed: No access token found', response);
        }
    }
    async handleMicrosoftLogin() {
        const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
        const redirectUri = `${process.env.REACT_APP_ASPEN_SELF_URL}/auth/callback/microsoft`;
        const scope = "openid profile User.Read";
        const responseType = "code";
        const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
        window.location.href = authUrl;
    }

    handleGoogleFailure(error) {
        console.error('Google login failed', error);
    }

    handleGoogleLogin() {
        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        const redirectUri = `${process.env.REACT_APP_ASPEN_SELF_URL}/auth/callback`;
        const scope = "openid email profile";
        const responseType = "code";
        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&response_type=${responseType}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
        window.location.href = authUrl;
    }
    onSubmit(formData) {
        let fromUrl = null;
        if (this.props.location.state && this.props.location.state.from) {
            fromUrl = this.props.location.state.from.pathname;
        }

        if (this.props.otpMode) {
            dispatch.login.otpLoginAsync({
                email: formData.email,
                otp: formData.otp,
                rememberMe: formData.rememberMe,
                fromUrl
            });
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const otp = urlParams.get('otp');
        let payload = {
            formData,
            fromUrl,
            otp
        }
        dispatch.login.loginAsync(payload);
    }

    onToggleOtpMode(enable, email) {
        if (enable) {
            dispatch.login.setOtpMode(true);
            dispatch.login.requestLoginOtpAsync({ email });
        } else {
            dispatch.login.setOtpMode(false);
        }
    }

    onResendOtp(email) {
        dispatch.login.resendLoginOtpAsync({ email });
    }

    resendConfirmation(formData) {
        dispatch.login.resendConfirmationAsync(formData.email);
    }

    gotToRegister(e) {
        e.preventDefault();
        dispatch.register.gotoRegister();
    }

    goToLogin(e) {
        e.preventDefault();
        dispatch.login.clear();
    }

    setCaptchaResponse(response) {
        dispatch.login.setCaptchaResponse(response);
    }

    gotToForgotPassword(e) {
        e.preventDefault();
        const { history } = this.props;
        history.push('/forgotpassword');
    }
    goToSetupCredentials(e) {
        e.preventDefault();
        const { history } = this.props;
        history.push('/setupcredentials');
    }

    goToNewAccount(e) {
        e.preventDefault();
        const { history } = this.props;
        history.push('/newaccount');
    }

    goToSubscription(e) {
        e.preventDefault();
        const { history } = this.props;
        history.push('/');
    }

    componentWillMount() {
        dispatch.app.cacheCleanup();
        dispatch.forgot.clearForgetData();
        dispatch.login.getVersion();
        //dispatch.login.getEnvData();
    }

    render() {
        const { loggingIn, loginError, sendingConfirmation, captchaEnabled, confirmationSent, sendConfirmationError } = this.props;

        let componentToRender = null;
        if (loginError === null || (loginError != null && loginError.message !== "Please verify your email")) {
            componentToRender = <LoginComponent loggingIn={loggingIn}
                loginError={loginError}
                gotToRegister={this.gotToRegister}
                onSubmit={this.onSubmit}
                gotToForgotPassword={this.gotToForgotPassword}
                goToSubscription={this.goToSubscription}
                version={this.props.version}
                handleGoogleLogin={this.handleGoogleLogin}
                handleMicrosoftLogin={this.handleMicrosoftLogin}
                goToSetupCredentials={this.goToSetupCredentials}
                otpMode={this.props.otpMode}
                otpSent={this.props.otpSent}
                otpExpiresAt={this.props.otpExpiresAt}
                otpRequestError={this.props.otpRequestError}
                onToggleOtpMode={this.onToggleOtpMode}
                onResendOtp={this.onResendOtp}
            />
        } else {
            if ((loginError != null && loginError.message === "Please verify your email") && !confirmationSent) {
                componentToRender = <ResendEmailComponent
                    sendingConfirmation={sendingConfirmation}
                    loginError={loginError}
                    captchaEnabled={captchaEnabled}
                    gotToRegister={this.gotToRegister}
                    onSubmit={this.resendConfirmation}
                    goToLogin={this.goToLogin}
                    setCaptchaResponse={this.setCaptchaResponse}
                    sendConfirmationError={sendConfirmationError}
                />
            } else {
                if (confirmationSent) {
                    componentToRender = <RegistrationConfirmation
                        action="Resend Confirmation"
                        email={this.props.emailId}
                        gotoLogin={this.goToLogin}
                    />
                }
            }
        }

        return (
            <div>
                {componentToRender}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: (state.loading.effects.login.loginAsync || state.loading.effects.login.googleLoginAsync) && state.loading.models.login,
        loginError: state.login.loginError,
        emailId: state.login.emailId,
        sendingConfirmation: state.loading.effects.login.resendConfirmationAsync && state.loading.models.login,
        sendConfirmationError: state.login.sendConfirmationError,
        confirmationSent: state.login.confirmationSent,
        version: state.login.version,
        captchaEnabled: state.login.captchaEnabled,
        otpMode: state.login.otpMode,
        otpSent: state.login.otpSent,
        otpExpiresAt: state.login.otpExpiresAt,
        otpRequestError: state.login.otpRequestError
    };
}

const connectedLoginPage = connect(mapStateToProps)(Login);

export { connectedLoginPage as Login }; 